/**
 * کلاس‌های Tailwind مشترک انجمن (به‌جای forum.css).
 * رنگ‌ها از پالت خود سایت (primary / gray / amber / emerald) می‌آیند، پس تم تیره‌ی سایت هم خودکار کار می‌کند.
 */

export const card = "rounded-[14px] border border-gray-200 bg-white";

const BTN_BASE =
    "inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap font-bold disabled:cursor-not-allowed disabled:opacity-60";

/** دکمه: variant = primary | amber | ghost */
export function btn(variant: "primary" | "amber" | "ghost" = "primary", sm = false) {
    const size = sm ? "h-[34px] rounded-lg px-4 text-[13px]" : "h-[42px] rounded-[10px] px-[22px] text-sm";
    const color =
        variant === "amber"
            ? "bg-amber-500 text-[#14202B] hover:brightness-95"
            : variant === "ghost"
              ? "border border-gray-200 bg-transparent text-gray-700 hover:bg-gray-100"
              : "bg-[#4451A3] text-white hover:bg-[#252360]";
    return `${BTN_BASE} ${size} ${color}`;
}

export function avatar(size: "md" | "sm" = "md", tone: "" | "a" | "g" | "i" = "") {
    const dim = size === "sm" ? "h-8 w-8 text-[12.5px]" : "h-10 w-10 text-[15px]";
    const bg =
        tone === "a" ? "bg-amber-500 text-[#14202B]" : tone === "g" ? "bg-emerald-700 text-white" : tone === "i" ? "bg-slate-600 text-white" : "bg-[#4451A3] text-white";
    return `grid shrink-0 place-items-center rounded-full font-bold ${dim} ${bg}`;
}

export const input =
    "w-full rounded-[10px] border border-gray-200 bg-gray-100 px-3.5 py-2.5 text-[14.5px] text-gray-900 outline-none placeholder:text-gray-500 focus:border-[#4451A3] focus:bg-white focus:text-gray-100";

export const hint = "text-[12.5px] text-gray-500";

export const chip = (on = false) =>
    `inline-block cursor-pointer rounded-full border px-4 py-1.5 text-[13px] font-semibold ${
        on ? "border-[#4451A3] bg-[#4451A3] text-white" : "border-gray-200 bg-white text-gray-700 hover:bg-gray-100"
    }`;

/** برچسب دسته‌بندی؛ color از API می‌آید: steel | amber | green */
export const catBadge = (color?: string) =>
    `inline-block rounded-full px-2.5 text-xs font-bold ${
        color === "amber" ? "bg-amber-100 text-amber-800" : color === "green" ? "bg-emerald-100 text-emerald-800" : "bg-indigo-50 text-[#4451A3]"
    }`;

export const tagChip = "rounded-md border border-gray-200 px-[9px] text-xs text-gray-700 hover:border-[#4451A3] hover:text-[#4451A3]";

export const solvedBadge =
    "mr-2 inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2.5 align-middle text-xs font-bold text-emerald-800";

/** ستون رأی + متن (کارت پرسش و پاسخ) */
export const qGrid = "grid grid-cols-[48px_minmax(0,1fr)] md:grid-cols-[62px_minmax(0,1fr)]";

export const voteBtn = (on = false) =>
    `grid h-[30px] w-[34px] cursor-pointer place-items-center rounded-lg border disabled:cursor-not-allowed disabled:opacity-50 ${
        on ? "border-[#4451A3] bg-[#4451A3] text-white" : "border-gray-200 bg-white text-gray-700 hover:border-[#4451A3] hover:text-[#4451A3]"
    }`;

export const adGrid = "grid grid-cols-1 gap-3.5 md:grid-cols-2";

export const price = "font-extrabold text-[#252360] dark:text-white";
